import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  CheckboxModule,
  DebugLanguageSwitchModule,
  IndicatorPopupModule,
  InputModule,
  RadiobuttonModule,
  SelectModule,
  ToggleModule,
  TextTooltipModule,
} from '@lib/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PopupIndicatorPipeModule, StaticMsgModule } from '@lib/pipes';
import { DialogDisplayServiceModule } from '@lib/services';
import { ServiceRequestPaymentInputPaymentMethodsComponent } from './service-request-payment-input-payment-methods.component';

@NgModule({
  declarations: [ServiceRequestPaymentInputPaymentMethodsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    RadiobuttonModule,
    ToggleModule,
    TextTooltipModule,
    CheckboxModule,
    SelectModule,
    OverlayModule,
    DebugLanguageSwitchModule,
    IndicatorPopupModule,
    PopupIndicatorPipeModule,
    DialogDisplayServiceModule,
    StaticMsgModule,
  ],
  exports: [ServiceRequestPaymentInputPaymentMethodsComponent],
})
export class ServiceRequestPaymentInputPaymentMethodsModule {}
